import * as React from 'react'
import { SVGProps } from 'react'
const SvgBag2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9 9V6a3 3 0 1 1 6 0v3M6 7h12l1 13H5L6 7Z"
      stroke="#1C1915"
      strokeLinecap="square"
    />
  </svg>
)
export default SvgBag2
